module.exports = __webpack_public_path__ + "img/note-hint.c28cfac3.png";